import { Autocomplete, Box, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
// import { useForm } from "../../../../hooks/useForm";
import style from "./style";
import CustomInput from "../../../../components/CustomInput";
import { LoadingButton } from "@mui/lab";
import { addExpense } from "../../../../constants/data";
import { AddExpenseValidation } from "../../../../helper/Validation";
import { useForm } from "../../../../hooks/useForm";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import DragAndDropMultiple from "../../../../components/DragAndDropMultiple";

const AddExpensePage = ({ banks, loading, createExpense, types }) => {
  const [date, setDate] = useState(dayjs())
  const [paymentMode, setPaymentMode] = useState()
  const [bankDetails, setBankDetails] = useState()
  const [type, setType] = useState();

  useEffect(() => {
    if (window.intlTelInputGlobals) {
      window.intlTelInputGlobals.loadUtils("build/js/utils.js");
    }
  }, []);

  const handleExpenseData = (data) => {
    createExpense(data, type, date, paymentMode, bankDetails)
  }

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    addExpense,
    AddExpenseValidation,
    handleExpenseData
  );

  const {
    name,
    amount,
    taxAmount,
    description,
  } = state;

  return (
    <Box px="5px" pt="20px">
      <form onSubmit={(e) => handleSubmit(e)}>
        <Typography sx={style.heading}>Add Expense</Typography>
        <Box>
          <Grid container>
            <Grid item xs={12} sx={style.card}>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Name<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="name"
                    fullWidth
                    placeholder="Enter Name"
                    value={name?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={name?.error}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Type<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Autocomplete
                    id="autocomplete"
                    freeSolo
                    options={types || []}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option?.name
                    }
                    onInputChange={(event, newInputValue) => {
                      if (newInputValue?.length <= 50) {
                        setType(newInputValue)
                      }
                    }}
                    onChange={(event, newValue) => {
                      setType(newValue?.name);
                    }}
                    renderInput={(params) => (
                      <>
                        <TextField
                          placeholder="Expense Type"
                          {...params}
                          sx={{ ...style.modalInput, ...style.inputSpace }}
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                            maxLength: 50,
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      </>
                    )}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Amount<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="amount"
                    fullWidth
                    type="number"
                    placeholder="Enter Amount"
                    value={amount?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={amount?.error}
                    inputProps={{ min: 0, step: "0.01" }}
                  />
                </Box>

              </Box>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Tax Amount
                  </InputLabel>
                  <CustomInput
                    name="taxAmount"
                    fullWidth
                    type="number"
                    value={taxAmount?.value}
                    placeholder="Enter Tax Amount"
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={taxAmount?.error}
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <InputLabel sx={style.label}>Date<span style={{ color: "red" }}>*</span></InputLabel>
                    <DatePicker sx={style.dateInput}
                      value={date}
                      onChange={(newValue) => { setDate(newValue); }}
                      maxDate={dayjs()}
                      slotProps={{
                        field: {
                          readOnly: true
                        }
                      }} />
                  </LocalizationProvider>
                </Box>

                <Box sx={style.inputBox}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Typography sx={style.label}>
                      Payment Method<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={paymentMode || ""}
                      onChange={(event) => {
                        setPaymentMode(event.target.value)
                        if (event?.target?.value !== "Bank") {
                          setBankDetails("")
                        }
                      }
                      }
                      name="PaymentMode"
                      sx={style.dropDownMenu}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                        Select
                      </MenuItem>
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="Bank">Bank</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box sx={style.inputSections}>
                <Box sx={style.inputBox}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Typography sx={style.label}>Bank</Typography>
                    <Select
                      value={bankDetails || ""}
                      onChange={(event) => {
                        setBankDetails(event.target.value)
                      }
                      }
                      disabled={paymentMode !== "Bank"}
                      name="bankDetails"
                      sx={style.dropDownMenu}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                        Select
                      </MenuItem>
                      {banks?.map((bank, index) => (
                        <MenuItem key={index} value={bank.name}>
                          {`${bank.name.toUpperCase()} - ${bank.accountNumber.slice(
                            -4
                          )}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                </Box>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>Description</InputLabel>
                  <CustomInput
                    name="description"
                    fullWidth
                    value={description?.value}
                    onChange={handleChange}
                    placeholder="Description"
                    onFocus={handleFocus}
                    error={description?.error}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>Upload File</InputLabel>
                  <DragAndDropMultiple />
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box px={2}>
            <LoadingButton
              //   loading={loading}
              variant="contained"
              sx={style.jobButtons}
              type="submit"
              disabled={!name?.value || name?.error || !amount?.value || amount?.error || !type || taxAmount?.error || !date || !paymentMode || description?.error || paymentMode === "Bank" && !bankDetails}
            >
              {"Save Expense"}
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </Box>
  );
}

export default AddExpensePage